var box = require('./box');
var PIXI = require('pixi.js');

function Platform (game, x, y, width, height, color, goal) {
    this.game = game;
    this.width = width;
    this.height = height;
    this.color = color;
    this.x = x;
    this.y = y;
    this.inited = false;
    this.body = null;
    this.goal = goal || false;
    this.init();
}

(function () {

    this.init = function() {
        if (this.inited) return;
        var bodyArgs = {
            x: this.x / this.game.scale,
            y: this.y / this.game.scale,
            parent: this,
            static: true
        };
        if (this.goal) bodyArgs.friction = .2;
        if (this.goal) {
            this.sprite = new PIXI.Sprite(this.game.textures.platform);
            this.sprite.anchor.set(.5, .5);
            this.sprite.scale.set(.3333);
            this.sprite.position.x = this.x;
            this.sprite.position.y = this.y;
            /*
            bodyArgs.points = [[0,0], [0,11], [9,11], [9,14], [12,14], [12,17], [24,17], [24,20], [27,20], [27,23], [51,23], [51,26], [60,26], [60,29], [63,29], [63,32], [72,32], [72,35], [77,35], [77,32], [86,32], [86,29], [89,29], [89,26],
            [98,26],
            [98,23],
            [122,23],
            [122,20],
            [125,20],
            [125,17],
            [137,17],
            [137,14],
            [140,14],
            [140,11],
            [149,11],
            [149,0 ]];
            */
           bodyArgs.points = [
               [-7.5, -1.3], [7.5, -1.3],
               [7.5, 1.3],
               [-7.5, 1.3],
           ];
            this.game.stage.addChild(this.sprite);
        } else {
            //this.sprite = new PIXI.TilingSprite(this.game.textures.ground, this.width, this.height);
            bodyArgs.width = this.width / this.game.scale / 2;
            bodyArgs.height = this.height / this.game.scale / 2;
            //this.sprite.position.x = this.x;
            //this.sprite.position.y = this.y;
        }
        this.body = this.game.makeBody(bodyArgs);
        this.inited = true;
        var plat = this.game.stage.children.pop();
        this.game.stage.children.unshift(plat);
    };

    this.move = function (x, y) {
        this.sprite.position.x = x;
        this.sprite.position.y = y;
        this.body.SetPosition(new box.Vec2(x / this.game.scale,
                               y / this.game.scale), 0);
    };

    this.render = function () {
        if (!this.inited) return;
        if (this.goal) {
            if (this.game.rocket.active) {
                this.sprite.alpha = 1.0 - this.game.touchgoal / 100;
            } else {
                this.sprite.alpha = 0;
            }
        //} else {
            //this.sprite.alpha = 1.0;
        }
    };

    this.destroy = function () {
        this.game.world.DestroyBody(this.body);
        if (this.sprite) {
            this.game.stage.removeChild(this.sprite);
        }
    }

}).call(Platform.prototype);

module.exports = Platform;



//////////////////
// WEBPACK FOOTER
// ./src/platform.js
// module id = 190
// module chunks = 0